/*
 * gcpDownloadUrl()
 * The staff download URL for a stored file answer.
 *
 * The server gives a file only to the account that owns its key (KTD9). A key
 * whose prefix is a UUID made in the client's browser names no row, so the
 * server also needs the response whose data lists the key: responseId. Send
 * it whenever the file comes from a response.
 */

export function gcpDownloadUrl({ key, name, responseId }) {
  const query = [
    `content=${encodeURIComponent(key)}`,
    `name=${encodeURIComponent(name)}`,
  ];

  if (responseId) query.push(`response_id=${encodeURIComponent(responseId)}`);

  return `/api/utility/gcp/download?${query.join("&")}`;
}
